import { combineReducers } from "redux";
import itemReducer from "./itemReducer";
import userReducer from "./userReducer";
import roomReducer from "./roomReducer";
import chessReducer from "./chessReducer";

const rootReducer = combineReducers({
	item: itemReducer,
	user: userReducer,
	room: roomReducer,
	chess: chessReducer,
});

export default rootReducer;
